import React, { Component } from "react";
import ModalMantenimiento from "./ModalMantenimiento/ModalMantenimiento";
import "./Budget.scss";
import adesisServices from "../../../services/adesisServices.js";

export default class Budget extends Component {
  constructor() {
    super();
    this.state = {
      date: `${new Date().getDate()}/${new Date().getMonth() +
        1}/${new Date().getFullYear()}`
    };
    this.adesisServices = new adesisServices();
  }

  scrollToWearPieces = () => {
    if (window.innerWidth <= 425) {
      let elmnt = document.getElementById("wear-pieces");
      elmnt && elmnt.scrollIntoView();
    } else {
      let elmnt = document.getElementById("price-container-scroll");
      elmnt && elmnt.scrollIntoView();
    }
  };

  sendWallet = () => {
    let model;
    let total = this.props.maintenanceCost + this.props.wearPartsCost;
    let mantenimientoV = [];
    let mantenimientoR = [];

    if (this.props.selectedModel) {
      model = this.props.selectedModel.name;
    } else {
      model = this.props.carInfo.modelName;
    }

    this.props.thingsToDo.map(piece => {
      if (piece.cTipo.includes("V")) {
        mantenimientoV.push(piece.cDescripcion);
      } else {
        mantenimientoR.push(piece.cDescripcion);
      }
    });

    const sendWalletData = {
      Description: "Calculadora de Mantenimiento",
      Fecha: this.state.date,
      Modelo: model,
      DireccionConcesionario: this.props.selectedWorkshops.DealershipAddress,
      Concesionario: this.props.selectedWorkshops.DealershipName,
      CosteMantenimiento: this.props.maintenanceCost.toFixed(2),
      CostePiezas: this.props.wearPartsCost.toFixed(2),
      PVPTotal: total.toFixed(2)
    };

    this.adesisServices.getPkPass(sendWalletData).then(response => {
      // window.open(response.data.Url, "_blank");
      this.setState({ ...this.state, pkPass: response.data.Url });
    });
  };

  setParentPosition = () => {
    let sData;
    window.parent.postMessage("Modal", process.env.REACT_APP_POSTMSG);
    // this.receiveMessage = event => {
    //   console.log('sData: ', event.data)
    //   sData = event.data;
    //   let auxArr = sData.split("-");
    //   let parentPosition = Number(auxArr[1]);
    //   let windowHeigh = Number(auxArr[0]);
    //   this.setState({ ...this.state, parentPosition, windowHeigh }, () => {});
    // };
    // window.addEventListener("message", this.receiveMessage, false);
  };

  showCondition = () =>{
  
     if (parseInt(document.getElementsByName('distanceSelected')[0].value.split('km')[0])<=150){
       return (
<p><b>Extensión de Garantía Toyota Relax: </b>  
Además, cada vez que realizas tu mantenimiento con nosotros tienes 
una año de garantía adicional GRATIS hasta los 10 años o 160.000 km 
(excepto vehículos destinados a servicio público)</p>
    );
     }
  else return
    
  }

  showAdBlueDescription=()=>{
    if (this.props.precioNoIncluyeAdblue){
      return (
          <div>
            <p className="ad-blueP">
            El precio no incluye AD-BLUE.
          </p>
        </div>
      );
    }
    else return
  }
  render() {
    return (
      <React.Fragment>
        <div className="row" id="presupuesto">
          <div className="col-12">
            <div className="title">
              <h3 className="small-title text-center">
                Este es tu presupuesto
              </h3>
            </div>
          </div>
        </div>
        <div
          id="separador"
          className="container-with-margin container-with-margin-right "
        >
          <div className="row">
            {/* <div className="col-sm-12 col-md-3">
              <div id="price-container-scroll" className="price-container">
                <span>
                  {this.props.maintenanceCost.toFixed(2).replace(".", ",")}€
                </span>
                <p>Operaciones de mantenimiento</p>
                <p
                  data-toggle="modal"
                  data-target="#queIncluyeMantenimiento"
                  className="cursorPointer"
                  onClick={this.setParentPosition}
                >
                  ¿Qué incluyen las operaciones de mantenimiento?
                </p>

                <ModalMantenimiento
                  fuelSelected={this.props.fuelSelected||this.props.carInfo.fuel}
                  parentPosition={this.state.parentPosition}
                  thingsToDo={this.props.thingsToDo}
                  precioNoIncluyeAdblue={this.props.precioNoIncluyeAdblue}
                  
                />
              </div>
            </div> */}

            {/* <div className="col-sm-12 col-md-1">
              <div className="sig-container">+</div>
            </div> */}

            {/* <div className="col-sm-12 col-md-3">
              <div className="price-container">
                <span>
                  {this.props.wearPartsCost.toFixed(2).replace(".", ",")}€
                </span>
                <p>Piezas de desgaste</p>
                <p
                  onClick={this.scrollToWearPieces}
                  className="cursorPointer red"
                >
                  Añadir piezas de desgaste
                </p>
              </div>
            </div> */}

            {/* <div className="col-sm-12 col-md-1">
              <div className="sig-container">=</div>
            </div> */}

            <div className="col-sm-12 col-md-4 price-total" style={{marginLeft: 'auto', marginRight: 'auto'}}>
              <div className="price-container total">
                <span>
                  {(this.props.maintenanceCost + this.props.wearPartsCost)
                    .toFixed(2)
                    .replace(".", ",")}
                  €
                </span>
                <p>Total estimado. IVA incluido</p>
                {/* <p>IVA incluido</p> */}
                <p
                  data-toggle="modal"
                  data-target="#queIncluyeMantenimiento"
                  className="cursorPointer"
                  onClick={this.setParentPosition}
                  style={{ fontSize: 15 }}
                >
                  <img src="./images/maintenance.png" style={{ width: 20, marginTop: -2 }} alt="img-icon" /> ¿Qué incluyen las operaciones de mantenimiento?
                </p>

                <ModalMantenimiento
                  fuelSelected={this.props.fuelSelected||this.props.carInfo.fuel}
                  parentPosition={this.state.parentPosition}
                  thingsToDo={this.props.thingsToDo}
                  precioNoIncluyeAdblue={this.props.precioNoIncluyeAdblue}
                  
                />
                <div
                  className="info-icon"
                  data-toggle="modal"
                  data-target="#modalCondiciones"
                  id="totalInfo"
                >
                  {/* <img src="./images/info_icon.png" alt="img-icon" /> Ver condiciones */}
                  <img src="./images/info.png" style={{ width: 20 }} alt="img-icon" /> Ver condiciones
                </div>
                <div
                  className="modal fade"
                  id="modalCondiciones"
                  tabIndex="-1"
                  role="dialog"
                  aria-labelledby="modalCondicionesTitle"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog  modal-xl"
                    style={{ top: this.state.parentPosition }}
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        {/* <img src="./images/info_icon.png" alt="img-icon" id="mod_img"/> */}
                        <img src="./images/info.png" style={{ width: 20 }} alt="img-icon" id="mod_img"/>
                        &nbsp;&nbsp;
                        <span style={{ fontSize: 22, marginTop: 'auto', marginBottom: 'auto' }}>Condiciones de Mantenimiento</span>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">
                            <img src="./images/ico-Cerrar.png" style={{ width: 16 }} alt="img-icon" />
                          </span>
                        </button>
                      </div>

                      <div className="modal-body" style={{ paddingRight: '4rem' }}>
                        <h5 className="modal-title" id="modalCondicionesTitle">
                        </h5>
                        <div id="mod_condiciones">
                          {/* <p><b>Mantenimientos:</b> Para mantenimientos superiores a 180.000 km. ó 12 años, por favor, consulte con su <a id="linkModal" href="https://www.toyota.es/#/ajax/%2Fforms%2Fforms%3Ftab%3Dpane-dealer%26showAllResults%3Dtrue" target="_blank">concesionario</a>.</p>
                          <p><b>Precios:</b> En nuestra calculadora se muestran de manera orientativa los precios máximos recomendados. En algún caso
                          puntual podría surgir alguna variación en cuanto al precio real. Por favor, consulte en su concesionario o reparador
                          autorizado el presupuesto definitivo.</p>
                          <p><li> Recambios, mano de obra y 21% IVA incluidos. SIGAUS no incluido.</li></p>
                          <p><li> NO se incluyen descuentos y promociones del servicio oficial.</li></p>
                          <p><b>Aceite:</b> Este mantenimiento está calculado con aceite sintético 5w30 PFE (Premium Fuel Economy). Su bajo contenido en
                          cenizas sulfatadas, fósforo y azufre proporcionan una mayor protección medioambiental, maximizan la vida del convertidor
                          catalítico a la vez que reducen el consumo y las emisiones de CO2.</p>
                          <p><b>SIGAUS:</b> Valor máximo a pagar: 0,054€ por cada litro de aceite, alrededor de 25cent por coche (GESTIÓN DE ACEITES
                          USADOS RD 679/2006 2 junio 2006).</p>
                          <p><b>Chequeo Integral del Sistema Híbrido:</b> A partir del día 1 de noviembre de 2014, todos los mantenimientos de los vehículos
                          híbridos Toyota incluyen este chequeo. Podrá obtener más información en el siguiente enlace <a id="linkModal" href="https://www.toyota.es/service-and-accessories/service-and-maintenance/hybrid-service" target="_blank">Chequeo Integral del Sistema
                          Hibrido</a> o consultando a su asesor de servicio (aplicable a todos los híbrido excepto vehículos de Renting/Leasing y Taxi).</p>
                          <p><b>Uso intensivo:</b> Taxis, Flotas, autoescuelas, VTC, en general vehículos sometidos a un uso intensivo podrían requerir un tipo
                          de mantenimiento específico con operaciones de mano de obra y recambios no mostrados en esta calculadora, motivo por
                          el que el precio mostrado en esta calculadora de mantenimiento podría variar. En este caso por favor consulte en su
                          concesionario o reparador autorizado el presupuesto definitivo.</p>
                          <p><b>Chequeo de componentes mecánicos y electrónicos: </b>desde el 13 de mayo de 2019 hemos incorporado en todos nuestros mantenimientos este chequeo de salud para revisar los componentes de tu vehículo y garantizar el correcto funcionamiento.</p> */}
                         {/* {this.showCondition()} */}
                         {/* {this.showAdBlueDescription()} */}

                          <p>
                            La seguridad y satisfacción de nuestros clientes es la máxima prioridad. En todo lo que hacemos tratamos que Vd. tenga una experiencia excepcional.
                            Para que Vd. obtenga la máxima satisfacción de su vehículo, le recordamos la conveniencia de cumplir con el Programa de Mantenimiento establecido por el fabricante de su vehículo.
                            Nuestra Red de Centros Autorizados Lexus está a su completa disposición para realizarlo.
                          </p>
                          <p>
                            <b>Recambios, mano de obra y 21% IVA incluidos. SIGAUS (gestión de aceite, usado) no incluido. (GESTIÓN DE ACEITES USADOS RD 679/2006 2 junio 2006)</b>
                          </p>
                          <p>
                            * Estos precios están sujetos a cambios según las especificaciones particulares de cada modelo, o modificaciones en referencias y precios unitarios. Consúltenos.
                          </p>
                          <p>
                            * El precio del mantenimiento está calculado utilizando aceite sintético Lexus Genuine Motor Oil 5W30 PFE.
                            Este aceite posee mayor capacidad de trabajo a altas y bajas temperaturas que otros aceites no sintéticos.
                            Su utilización reduce la cantidad de cenizas generadas en el proceso de combustión del motor evitando la obstrucción de las líneas de escape a la vez que disminuye el consumo de combustible y los niveles de emisiones de CO2, proporcionando una mayor protección del medio ambiente.
                          </p>
                          <p>
                            No obstante, tenemos a su disposición otros aceites con especificaciones y precios superiores que usted puede solicitar en cualquiera de nuestros servicios oficiales.
                          </p>
                          <p>
                            Con <b>LEXUS RELAX</b>, disfrute de 1 año o 15.000kms de garantía realizando el mantenimiento en nuestros Centros Autorizados Lexus (prorrogable hasta 10 años o 185.000 kms)
                            Consulte Términos y Condiciones en: <a href="https://www.lexusauto.es/propietarios/garantia/lexus-relax/terminos-y-condiciones-lexus-relax">www.lexusauto.es/propietarios/garantia/lexus-relax/terminos-y-condiciones-lexus-relax</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div
              className={`col-12 save-in-wallet-container ${this.state.pkPass &&
                "download-activate"}`}
            >
              <img
                onClick={this.sendWallet}
                src="./images/save-in_wallet.png"
                alt="wallet-img"
              />
              {this.state.pkPass && (
                <a className="download" href={this.state.pkPass}>
                  <img src="images/ico-descargar.png" alt=""/>
                </a>
              )}
            </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
